import { APP_NAME } from "../../dth/constants";
import { _t } from "../../languageHandler";

/**
 * Get a localised error message for GeolocationPositionError error codes
 * @param code - error code from GeolocationPositionError
 * @returns
 */
export const positionFailureMessage = (code: number): string | undefined => {
    const brand = APP_NAME;
    switch (code) {
        case 1:
            return _t("location_sharing.failed_permission", { brand });
        case 2:
            return _t("location_sharing.failed_generic");
        case 3:
            return _t("location_sharing.failed_timeout");
        case 4:
            return _t("location_sharing.failed_unknown");
    }
};
